import { Chip, SxProps, Theme } from "@mui/material";

interface StatusChipProps {
	status: string;
	colorMap: Record<string, "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning">;
	defaultColor?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
	size?: "small" | "medium";
	sx?: SxProps<Theme>;
}

export default function StatusChip({ status, colorMap, defaultColor = "default", size = "small", sx }: StatusChipProps) {
	const color = colorMap[status] || defaultColor;
	return <Chip label={status} color={color} size={size} sx={sx} />;
}
